// extracted by mini-css-extract-plugin
module.exports = {"panelHeader":"styles-module__panelHeader___2Tite","panelTitle":"styles-module__panelTitle___3AmrO","panelSubtext":"styles-module__panelSubtext___2bgDb"};